import { AuthState } from '@aws-amplify/ui-components';
import {
  Box,
  Container,
  Flex,
  Icon,
  Link,
  Menu,
  MenuItem,
  MenuButton,
  MenuList,
  Button,
  Text,
} from '@chakra-ui/react';
import { QuestionOutlineIcon } from '@chakra-ui/icons';
import { routerActions } from 'connected-react-router';
import React, { memo, useEffect, useState } from 'react';
import { FiHome, FiCalendar, FiSettings, FiUser, FiLogOut, FiBookOpen } from 'react-icons/fi';
import { TiArrowSortedDown } from 'react-icons/ti';
import { useAppDispatch, useAppSelector } from '../hooks';
import { signOutAsync } from '../slice/userSlice';
import { startLoading, stopLoading } from '../slice/loadingSlice';
import './shell.scss';
import { useLocation } from 'react-router-dom';
import { ASSETS_IMG } from '../utils/assets';
import { URL_PRIVACY, URL_TERMS, URL_TRANSACTIONS, LEARNER_V2_URL } from '../configs';
// 所属管理(企業側)は一旦非表示。manager 側で操作を整理してから戻す
// import { useAffiliationMe } from '../hooks/useAffiliationMe';

const NavItem = ({ icon, title, active, onClick, children, pathname, is_external, href }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = Array.isArray(children) && children.length > 0;

  return (
    <Flex mt={3} flexDir="column" w="100%">
      <Link
        backgroundColor={active ? '#cbe7ff' : 'inherit'}
        p={3}
        borderRadius={2}
        _hover={{ textDecor: 'none', backgroundColor: '#e8f4ff' }}
        onClick={() => {
          if (hasChildren) {
            setIsOpen(!isOpen);
          } else if (!is_external) {
            onClick();
          }
        }}
        href={is_external ? href : undefined}
        target={is_external ? '_blank' : undefined}
      >
        <Flex align="center" justify="space-between">
          <Flex align="center">
            {icon && <Icon as={icon} fontSize="xl" color={active ? '#82AAAD' : 'gray.500'} />}
            <Text ml={5}>{title}</Text>
          </Flex>
          {hasChildren && (
            <TiArrowSortedDown
              style={{
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
              }}
            />
          )}
        </Flex>
      </Link>

      {/* Sub-navigation */}
      {hasChildren && isOpen && (
        <Box ml={8} mt={1}>
          {children.map((child: any) => (
            <Link
              key={child.title}
              display="block"
              p={2}
              borderRadius={2}
              backgroundColor={child.pathname === pathname ? '#dff1ff' : 'inherit'}
              _hover={{ backgroundColor: '#f0faff' }}
              onClick={() => {
                if (!child.is_external) {
                  return onClick(child.pathname);
                }
              }}
              href={child.is_external ? child.pathname : undefined}
              target={child.is_external ? '_blank' : undefined}
            >
              {child.title}
            </Link>
          ))}
        </Box>
      )}
    </Flex>
  );
};

const navs = [
  {
    icon: FiHome,
    title: 'ダッシュボード',
    active: false,
    pathname: '/top',
  },
  {
    icon: FiUser,
    title: '学習者',
    active: false,
    pathname: '#',
    children: [
      {
        title: '学習者一覧',
        pathname: '/learners',
      },
    ],
  },
  {
    icon: FiCalendar,
    title: 'レッスン',
    active: false,
    pathname: '#',
    children: [
      {
        title: 'レッスン一覧',
        pathname: '/lessons',
      },
      {
        title: 'フィードバック一覧',
        pathname: '/feedback',
      },
      // {
      //   title: '申し送り一覧',
      //   pathname: '/lesson_notes',
      // },
    ],
  },
    {
    icon: FiBookOpen,
    title: '学習者アプリ',
    active: false,
    pathname: `${LEARNER_V2_URL}/company/top`,
    is_external: true,
  },
  {
    icon: FiSettings,
    title: '設定',
    active: false,
    pathname: '#',
    children: [
      // {
      //   title: '契約プラン一覧',
      //   pathname: '/agreement',
      // },
      // {
      //   title: 'プロフィール',
      //   pathname: '#',
      // },
      {
        title: 'お問い合わせ',
        pathname: '/contact',
      },
      {
        title: '利用契約',
        pathname: URL_TERMS,
        is_external: true,
      },
      {
        title: 'プライバシーポリシー',
        pathname: URL_PRIVACY,
        is_external: true,
      },
      {
        title: '特定商取引法に基づく表記',
        pathname: URL_TRANSACTIONS,
        is_external: true,
      },
    ],
  },
];

export interface IShellProps {
  children: React.ReactNode;
}

export var currentUserId = React.createContext('');

export const Shell: React.NamedExoticComponent<IShellProps> = memo(({ children }) => {
  const dispatch = useAppDispatch();
  const historyState = useAppSelector((state) => state.router);
  const userState = useAppSelector((state) => state.user);
  const [companyId, setCompanyId] = useState<any>('くらしスタディ はなすプラス');
  const onClickBrand = () => dispatch(routerActions.push({ pathname: '/top' }));
  const { pathname } = useLocation();
  // 所属管理(企業側)は一旦非表示。manager 側で操作を整理してから戻す
  // 所属管理は、全体管理者(ルートの管理者)にだけメニューを表示する
  // const { isRootAdmin } = useAffiliationMe(userState.user?.['cognito:companyId'] as string | undefined);
  // const menuItems = isRootAdmin
  //   ? navs.map((nav) =>
  //       nav.title === '学習者'
  //         ? { ...nav, children: [...(nav.children ?? []), { title: '所属管理', pathname: '/affiliations' }] }
  //         : nav,
  //     )
  //   : navs;
  const menuItems = navs;

  // サインアウトはトークンの失効で通信が発生して数秒かかるため、その間は画面全体を読み込み中にして操作できないようにする
  const onClickSignout = async () => {
    dispatch(startLoading());
    try {
      await dispatch(signOutAsync());
    } finally {
      dispatch(stopLoading());
    }
  };

  useEffect(() => {
    return;
  });

  if (pathname.includes('room-call')) {
    return <Container className="room-call-div-container">{children}</Container>;
  }

  return (
    <>
      <Box
        display="flex"
        height="60px"
        borderBottom="1px solid #ddd"
        justifyContent="space-between"
        boxShadow={'sm'}
        alignItems="center"
        position="fixed"
        top="0"
        left="0"
        right="0"
        zIndex={500}
        bg="white"
      >
        <Box alignItems="center" display="flex" flexWrap="wrap">
          <Box className="Logo" onClick={onClickBrand} style={{ cursor: 'pointer' }}>
            <img src={ASSETS_IMG.logo01} alt={companyId} />
          </Box>
          <br />
          <sub style={{ color: '#3f83bf', marginLeft: '5px', bottom: 'unset' }}>
            {companyId !== undefined && companyId.length > 0 ? ' | ' : ''} 管理システム
          </sub>
        </Box>
        <Box hidden={!(userState.authState === AuthState.SignedIn && userState.user)}>
          <Flex>
            <Menu>
              <MenuButton
                as={Button}
                fontSize="12px"
                fontWeight={500}
                marginRight={3}
                height={'32px'}
                background={'#f4f5f9'}
                border="1px solid"
                borderColor="gray.300"
                borderRadius="4px"
                padding="1px 12px"
                rightIcon={<TiArrowSortedDown size={13} />}
                _hover={{ background: '#f4f5f9', borderColor: 'gray.500' }}
                _focus={{ background: '#f4f5f9', boxShadow: 'none' }}
                _active={{ background: '#f4f5f9' }}
              >
                {userState.user?.email}
              </MenuButton>
              <MenuList>
                <MenuItem
                  as={Button}
                  fontSize="14px"
                  fontWeight={400}
                  leftIcon={<Icon as={FiUser} boxSize="22px" color="gray.600" />}
                  background={'white'}
                  onClick={() => dispatch(routerActions.push({ pathname: '/profile' }))}
                  justifyContent="flex-start"
                  ml={'7px'}
                  _hover={{ background: 'gray.100' }}
                  _focus={{ background: 'transparent', boxShadow: 'none' }}
                  _active={{ background: 'transparent' }}
                >
                  プロフィール
                </MenuItem>
                <MenuItem
                  as={Button}
                  fontSize="14px"
                  fontWeight={400}
                  leftIcon={<Icon as={FiLogOut} boxSize="22px" color="red.500" fontWeight="bold" />}
                  background={'white'}
                  onClick={onClickSignout}
                  color="red.500"
                  justifyContent="flex-start"
                  ml={'7px'}
                  _hover={{ background: 'transparent', color: 'red.500' }}
                  _focus={{ background: 'transparent', boxShadow: 'none' }}
                  _active={{ background: 'transparent' }}
                >
                  Signout
                </MenuItem>
              </MenuList>
            </Menu>
            {/* <Box>
              <a href="#">
                <div
                  style={{
                    border: 'none',
                    background: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    outline: 'none',
                  }}
                >
                  <QuestionOutlineIcon boxSize={7} color="#3182ce" />
                </div>
              </a>
            </Box> */}
          </Flex>
        </Box>
      </Box>
      <Flex>
        <Flex
          pos="sticky"
          borderRight="1px solid #ddd"
          boxShadow="sm"
          minW="210px"
          flexDir="column"
          justifyContent="space-between"
          top="0"
          h="100vh"
          overflowY="auto"
          hidden={!(userState.authState === AuthState.SignedIn && userState.user)}
        >
          <Flex className="scrollable-sidebar" flexDir="column" marginTop={'60px'} as="nav">
            {menuItems.map((nav) => (
              <NavItem
                key={nav.title}
                icon={nav.icon}
                title={nav.title}
                active={nav.pathname === historyState.location.pathname}
                pathname={historyState.location.pathname}
                onClick={(pathname?: string) => {
                  dispatch(routerActions.push(pathname || nav.pathname));
                }}
                children={nav.children}
                is_external={nav.is_external}
                href={nav.pathname}
              />
            ))}
          </Flex>
        </Flex>
        <Container
          className="Shell-children main-content"
          marginTop={'75px'}
          maxWidth={'100vw'}
          marginX={'2em'}
        >
          {children}
        </Container>
      </Flex>
    </>
  );
});
